var render, staticRenderFns
import script from "./AppointmentsChart.vue?vue&type=script&lang=js"
export * from "./AppointmentsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4247735b')) {
      api.createRecord('4247735b', component.options)
    } else {
      api.reload('4247735b', component.options)
    }
    
  }
}
component.options.__file = "src/view/pages/components/Statistics/AppointmentsChart.vue"
export default component.exports